import { useEffect } from 'react';
import { useTour } from '@reactour/tour';

const TourClearer: React.FC = () => {
  const { setSteps } = useTour();

  useEffect(() => {
    setSteps?.([]);
  }, []);

  return null;
};

export default TourClearer;
